import { render, staticRenderFns } from "./FieldList.vue?vue&type=template&id=dc81c0dc&scoped=true&"
import script from "./FieldList.vue?vue&type=script&lang=js&"
export * from "./FieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc81c0dc",
  null
  
)

export default component.exports